import {
  InvalidCharacterFirstNamesError,
  InvalidCharacterLastNamesError,
  InvalidFirstNamesError,
  InvalidLastNamesError,
} from '../errors'

// Map User Profile API error codes to ValidationError classes
// Codes 304, 306, 310 are path-dependent (givenName vs surname)
// Code 312 is path-independent
const errorCodeMap = {
  304: {
    // FIELD_REQUIRED
    requiresPath: true,
    givenName: InvalidFirstNamesError,
    surname: InvalidLastNamesError,
  },
  306: {
    // INVALID_VALUE - Use InvalidCharacterError for better UX
    requiresPath: true,
    givenName: InvalidCharacterFirstNamesError,
    surname: InvalidCharacterLastNamesError,
  },
  310: {
    // PUBLIC_FIELD_NOT_ALLOWED
    requiresPath: true,
    givenName: InvalidFirstNamesError,
    surname: InvalidLastNamesError,
  },
  312: InvalidFirstNamesError, // UPDATE_NOT_ALLOWED - path-independent
}

export default function throwUserProfileError(error) {
  // Parse User Profile API response body format
  const bodyError = findBodyError(error)
  if (bodyError) {
    const ErrorClass = mapErrorCodeAndPath(bodyError.code, bodyError.path)
    if (ErrorClass) {
      throw new ErrorClass()
    }
  }

  // No mapped error found, rethrow original
  throw error
}

function findBodyError(error) {
  // Parse User Profile API response body format
  // Returns first error from errors array
  const errors = error?.response?.data?.errors
  if (Array.isArray(errors) && errors.length > 0) {
    return {
      code: errors[0].code,
      message: errors[0].message,
      path: errors[0].path,
    }
  }
  return null
}

function mapErrorCodeAndPath(code, path) {
  const mapping = errorCodeMap[code]

  // Unknown error code
  if (!mapping) {
    return null
  }

  // Path-independent error (e.g., code 312)
  if (typeof mapping === 'function') {
    return mapping
  }

  // Path-dependent error requires path to determine field
  if (mapping.requiresPath && !path) {
    return null
  }

  // Determine field from path (e.g., "fullName.givenName" → givenName)
  const isGivenName = path?.includes('givenName')
  return isGivenName ? mapping.givenName : mapping.surname
}
